var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer menuText"},[_c('div',{staticClass:"footCon",style:({ fontSize: (_vm.$mq == 'sm') ? '16px' : '18px' })},[_vm._v("\n    © OLIVER HICKMAN MUSIC "+_vm._s(new Date().getFullYear())+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }